import AICloudDeveloperPage from "./AICloudDeveloperPage";

export default function DataEngineerPage() {
  return <AICloudDeveloperPage technology="data-engineer" />;
}
